<div class="landing" [class.landing--menu-open]="menuOpen()">
  <div class="header-bar" [class.header-bar--scrolled]="scrolled() || menuOpen()">
    <header class="site-header">
      <a class="brand" routerLink="/" aria-label="Savant Payments Gateway home" (click)="closeMenu()">
        <img class="brand-symbol" src="/logo-icon.png" width="35" height="35" alt="" />
        <span class="brand-name">Savant<small>PAYMENT GATEWAY</small></span>
      </a>

      <nav class="main-nav" aria-label="Main navigation">
        <a routerLink="/" fragment="payments">Payment options</a>
        <a routerLink="/" fragment="how-it-works">How it works</a>
        <a routerLink="/developers" routerLinkActive="nav-current" ariaCurrentWhenActive="page">Developers</a>
      </nav>

      <div class="header-actions">
        <app-theme-toggle />
        <a class="sign-in" routerLink="/auth/login">Sign in</a>
        <a class="btn btn--accent btn--sm header-cta" routerLink="/auth/signup" (click)="closeMenu()">
          Get started
          <span aria-hidden="true">↗</span>
        </a>
        <button
          class="nav-toggle"
          type="button"
          aria-controls="mobile-nav"
          [attr.aria-expanded]="menuOpen()"
          [attr.aria-label]="menuOpen() ? 'Close navigation' : 'Open navigation'"
          (click)="toggleMenu()"
        >
          <i [class]="menuOpen() ? 'ph ph-x' : 'ph ph-list'" aria-hidden="true"></i>
        </button>
      </div>
    </header>

    <div class="nav-sheet" id="mobile-nav" [class.nav-sheet--open]="menuOpen()" [attr.inert]="menuOpen() ? null : ''">
      <nav class="sheet-links" aria-label="Mobile navigation">
        <a routerLink="/" fragment="payments" (click)="closeMenu()">
          <i class="ph ph-wallet" aria-hidden="true"></i>
          <span>Payment options</span>
          <i class="ph ph-caret-right" aria-hidden="true"></i>
        </a>
        <a routerLink="/" fragment="how-it-works" (click)="closeMenu()">
          <i class="ph ph-path" aria-hidden="true"></i>
          <span>How it works</span>
          <i class="ph ph-caret-right" aria-hidden="true"></i>
        </a>
        <a routerLink="/developers" routerLinkActive="sheet-link--current" ariaCurrentWhenActive="page" (click)="closeMenu()">
          <i class="ph ph-code" aria-hidden="true"></i>
          <span>Developers</span>
          <i class="ph ph-caret-right" aria-hidden="true"></i>
        </a>
      </nav>

      <div class="sheet-actions">
        <a class="btn btn--secondary btn--block" routerLink="/auth/login" (click)="closeMenu()">Sign in</a>
        <a class="btn btn--accent btn--block" routerLink="/auth/signup" (click)="closeMenu()">
          Get started
          <span aria-hidden="true">↗</span>
        </a>
      </div>

      <p class="sheet-footnote">Payments for the way Zimbabwe does business.</p>
    </div>
  </div>

  @if (menuOpen()) {
    <button class="nav-backdrop" type="button" tabindex="-1" aria-hidden="true" (click)="closeMenu()"></button>
  }

  <main>
    <router-outlet></router-outlet>
  </main>

  <footer class="site-footer">
    <a class="footer-brand" routerLink="/" aria-label="Savant Payment Gateway home">
      <img src="/logo.png" width="160" height="29" alt="Savant Payment Gateway" />
    </a>
    <p>Payments for the way Zimbabwe does business.</p>
    <a routerLink="/auth/login">Sign in <span aria-hidden="true">↗</span></a>
    <small>© Savant Payments</small>
  </footer>
</div>
